const category = {
  id: null,
  name: null
}

export function create(data = {}) {
  const { name, id } = data

  return {
    ...category,
    id,
    name
  }
}

export function compare(categoryA, categoryB) {
  if (categoryA.name === categoryB.name) {
    return 0
  } else if (categoryA.name < categoryB.name) {
    return -1
  }
  return 1
}
